module.exports = __webpack_public_path__ + "static/img/4.0dece07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/4.png
// module id = A8hT
// module chunks = 0